import React from "react";
import { IconButton } from "@mui/material";
import { Link as RouterLink, useLocation } from "react-router-dom";


const ActionButtons = () => {
  const location = useLocation();
  return (
    <div style={{ display: "flex", alignItems: "center" }}>
      <IconButton
        component={RouterLink}
        to={`${location.pathname.split("?")[0]}epg/`}
      >
        <span class="material-symbols-outlined">tv_guide</span>
      </IconButton>
    </div>
  );
};

export default ActionButtons;
